import styled, { css } from 'styled-components'

export const OrdersWrapper = styled.div`
	width: 100%;
	position: relative;
	margin-bottom: 34px;
`

export const OrdersContainer = styled.div`
	display: flex;
	gap: 16px;

	@media (max-width: ${p => p.theme.sizes.breakPoints.small}) {
		${({ isCarousel }) =>
			isCarousel
				? css`
						flex-wrap: nowrap;
						overflow-x: auto;
						width: clamp(350px, 90vw, 600px);
						-webkit-overflow-scrolling: touch;
						scroll-snap-type: x mandatory;
						overscroll-behavior-x: contain;
						gap: 16px;
						touch-action: pan-x;
						&::-webkit-scrollbar {
							display: none;
						}
						-ms-overflow-style: none;
						scrollbar-width: none;
				  `
				: css`
						flex-direction: column;
						align-items: center;
						flex-wrap: nowrap;
						overflow-x: unset;
						width: 100%;
				  `}
	}
`

export const CardContainer = styled.div`
	gap:10px;
	background: white;
	border-radius: 12px;
	border: 1px solid #e0e0e0;
	padding: 20px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	${({ isCarousel }) =>
		isCarousel
			? css`
					flex: 0 0 auto;
					width: 320px;
			  `
			: `
      width: 100%;
        `}
`

export const CardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`

export const DownloadButton = styled.a`
	text-decoration: none;
	font-weight: 500;
	font-size: 14px;
	display: inline-flex;
	align-items: center;
	justify-content: flex-start;
	gap: 8px;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}
`
